import { TasteSummary, AxisWeight, CUISINE_KEYS, CUISINE_LABELS } from '../../types/tasteProfile';
import { PreferencePillStrip } from './PreferencePillStrip';

type CuisineHeatStripProps = {
  cuisineWeights: Record<string, AxisWeight>;
  summary: TasteSummary;
};

export const CuisineHeatStrip = ({ cuisineWeights, summary }: CuisineHeatStripProps) => (
  <PreferencePillStrip
    title="Cuisine preferences"
    keys={CUISINE_KEYS}
    labels={CUISINE_LABELS}
    weights={cuisineWeights}
    preferredKeys={summary.preferredCuisines}
    avoidedKeys={summary.avoidedCuisines}
  />
);
